import { Button, Flex, FlexProps, Text } from '@chakra-ui/react'
import { ActionButton, SolidActionButton } from '../../components/Buttons'
import { useProfileLayout } from '../../contexts/user/ProfileLayoutContext'
import { useExamListGroup } from './context'

export const EncounterListGroupHeader = ({
  title,
  flexProps,
}: {
  title: string
  flexProps?: FlexProps
}) => {
  const {
    onPrintSelected,
    isSelecting,
    printing,
    totalSelected,
    onStartSelecting,
    onCancelSelecting,
  } = useExamListGroup()
  const { layoutMode } = useProfileLayout()
  const mobileLayout = layoutMode === 'mobile'
  return (
    <Flex
      px={4}
      py={2}
      w="100%"
      bg="white"
      _dark={{ bg: 'gray.900' }}
      borderRadius={4}
      boxShadow="1px 1px 4px #00000077"
      align="center"
      flexWrap="wrap"
      rowGap={1}
      {...flexProps}>
      <Text
        fontSize="md"
        whiteSpace="nowrap"
        fontFamily="Hero-New"
        color="gray.700"
        _dark={{ color: 'gray.200' }}
        fontWeight={500}>
        {title}
      </Text>
      {isSelecting ? (
        <Flex ml="auto" align="center" gap={mobileLayout ? 2 : 4}>
          <Button variant="link" size={mobileLayout ? 'xs' : 'sm'} onClick={onCancelSelecting}>
            Cancel
          </Button>
          <SolidActionButton
            size={mobileLayout ? 'xs' : 'sm'}
            isLoading={printing}
            isDisabled={totalSelected === 0}
            onClick={onPrintSelected}>
            Print Selected ({totalSelected})
          </SolidActionButton>
        </Flex>
      ) : (
        <ActionButton ml="auto" size={mobileLayout ? 'xs' : 'sm'} onClick={onStartSelecting}>
          Print Multiple Encounters
        </ActionButton>
      )}
    </Flex>
  )
}
